var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homePage"},[_c('homeHeader'),_c('homeContent'),(false)?_c('homeFoot'):_vm._e(),_c('div',{staticClass:"fl_just_sp-betw"},[_c('homeFootLeft'),_c('homeFootRight')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }